<template>
  <modal
    size="small"
    class="Modal__callToActionAssinatura"
    :labels="{ cancel: 'Cancelar', submit: submitLabel }"
    @close="close"
    @save="save"
  >
    <div slot="content">
      <div class="Modal__content Content">
        <p class="Modal__title">
          {{ title }}
        </p>
        <div>
          <slot name="content">
            <p class="Modal__sub">
              Essa funcionalidade não está disponível no seu plano atual, migre
              para um plano maior para ter acesso.
            </p>
          </slot>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from "../monitoramentos/Modal.vue";
export default {
  components: {
    Modal
  },
  props: {
    title: {
      default: "Disponível apenas para assinantes",
      type: String
    },
    submitLabel: {
      default: "Assinar",
      type: String
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    save() {
      this.$emit("save");
    }
  }
};
</script>

<style lang="stylus">
.Modal__callToActionAssinatura
  font-weight 400
  .Modal__footer
    justify-content flex-end
  .Modal__footer .button:first-child
    background none
    margin-right 1rem
  .Modal__footer .button:last-child
    background-color rgba(35, 147, 174, 1)
    color rgb(255, 255, 255)
  .Modal__footer .button:last-child:hover
    background-color rgba(35, 147, 174, 0.8)
  .Modal__footer .button:last-child:active
    background-color rgba(35, 147, 174, 0.6)
  .Modal__content
    max-width 768px
  .Modal__title
    font-size 18px
    font-weight 600
    color rgb(72, 72, 72)
  .Modal__sub
    margin-top 1rem
    color rgba(72, 72, 72, 0.8)
</style>

<style lang="stylus">
.bar-options .btn.-medium
  padding 9px 24px
  margin-right 0
</style>
